import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { photos } from '../../data/site';
import { ButtonLink } from '../ui/ButtonLink';
import { Container } from '../ui/Container';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const reduce = useReducedMotion();
  const enter = (delay: number) => reduce ? {} : {
    initial: {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease,
      delay
    }
  };
  return <section id="top" aria-labelledby="hero-title" className="bates-hero on-dark relative isolate overflow-hidden bg-ink text-white" data-id="element-162" data-mp="5nvx9hzlhhq4">
      <img src={photos.clubGroup} alt="A large group of children, teens and adults together at Bates Taekwondo" className="bates-hero-photo absolute inset-x-0 bottom-0 w-full" fetchPriority="high" data-id="element-163" data-mp="3rwoqxs68kbbk" />
      <div className="bates-hero-shade absolute inset-0" aria-hidden="true" data-id="element-164" data-mp="1q525e65458mh" />
      <Container className="relative z-10 pt-12 text-center sm:pt-14 lg:py-7 lg:text-left" data-id="element-165" data-mp="1mwm1pyy9nq5y">
        <div className="mx-auto max-w-[980px] lg:mx-0 lg:max-w-[540px]" data-id="element-166" data-mp="1rv5qs885pi2j">
          <motion.p {...enter(0)} className="font-display text-[15px] font-semibold uppercase tracking-[0.18em] text-white/90" data-id="element-167" data-mp="1rtcikohwapsf">
            Taekwondo in Albuquerque
          </motion.p>
          <motion.h1 {...enter(0.05)} id="hero-title" className="text-balance mt-4 font-display text-[3.15rem] font-bold uppercase leading-[0.94] tracking-[-0.01em] sm:text-[4.25rem] lg:mt-3 lg:text-[3.6rem]" data-id="element-168" data-mp="1hxhw1iajwakd">
            Big confidence starts with <span className="text-[#FF6268]" data-id="element-169" data-mp="1vw92cij68rxy">one small step.</span>
          </motion.h1>
          <motion.p {...enter(0.1)} className="text-pretty mx-auto mt-5 max-w-[900px] text-[1.025rem] leading-relaxed text-white/90 sm:text-lg lg:mx-0 lg:mt-4 lg:max-w-[500px] lg:text-base" data-id="element-170" data-mp="20v2bjyrfdwsb">
            At Bates Taekwondo, children, teens and adults get personal coaching, positive challenges they can actually
            meet, and a place where they belong. Come try a class and see how it feels.
          </motion.p>
          <motion.div {...enter(0.15)} className="mt-7 flex flex-col justify-center gap-3 sm:flex-row sm:flex-wrap lg:mt-5 lg:justify-start" data-id="element-171" data-mp="2y9tufjppe4cn">
            <ButtonLink href="#first-class" data-id="element-172" data-mp="2p8vvvgy1ap1g">Book a Free Trial Class</ButtonLink>
            <ButtonLink href="#programs" variant="outlineLight" className="bg-black/60" icon={<ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-174" data-mp="2kau324at3bcs" />} data-id="element-173" data-mp="2payj5t7sy42h">
              Explore Programs
            </ButtonLink>
          </motion.div>
        </div>
      </Container>
    </section>;
}